"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ResourceList = void 0;
var RTTI_ResourceList_1 = require("./RTTI_ResourceList");
Object.defineProperty(exports, "RTTI_ResourceList", { enumerable: true, get: function () { return RTTI_ResourceList_1.RTTI_ResourceList; } });
//# sourceMappingURL=index.js.map